// Function to initialize a single slider
function initP7Slider(sliderBlock) {
    if (!sliderBlock || sliderBlock.classList.contains('p7-slider-initialized')) {
        return;
    }

    const mainSliderEl = sliderBlock.querySelector('.p7-slider-main');
    const thumbsSliderEl = sliderBlock.querySelector('.p7-slider-thumbs');

    if (!mainSliderEl) return;

    const autoPlay = sliderBlock.dataset.autoplay === 'true';
    const delay = parseInt(sliderBlock.dataset.delay) || 3000;
    const loop = sliderBlock.dataset.loop === 'true';
    const showNavigation = sliderBlock.dataset.navigation === 'true';
    const nextBtn = sliderBlock.querySelector('.swiper-button-next');
    const prevBtn = sliderBlock.querySelector('.swiper-button-prev');

    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded yet, retrying...');
        setTimeout(() => initP7Slider(sliderBlock), 500);
        return;
    }

    let thumbsSwiper = null;
    if (thumbsSliderEl) {
        thumbsSwiper = new Swiper(thumbsSliderEl, {
            slidesPerView: 6,
            spaceBetween: 10,
            watchSlidesProgress: true,
            freeMode: false,
            breakpoints: {
                320: { slidesPerView: 3, spaceBetween: 5 },
                768: { slidesPerView: 3, spaceBetween: 10 },
                1150: { slidesPerView: 6, spaceBetween: 10 }
            }
        });
    }

    const mainSwiper = new Swiper(mainSliderEl, {
        loop: loop,
        speed: 500,

        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false,
        threshold: 5,

        autoplay: autoPlay ? {
            delay: delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        } : false,

        navigation: showNavigation ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
        } : false,

        thumbs: {
            swiper: thumbsSwiper
        },

        observer: true,
        observeParents: true
    });



    sliderBlock.classList.add('p7-slider-initialized');
    sliderBlock.swiperInstance = mainSwiper;
}

function initializeAllP7Sliders() {
    const sliders = document.querySelectorAll('.p7-slider-block:not(.p7-slider-initialized)');
    sliders.forEach(initP7Slider);
}

document.addEventListener('DOMContentLoaded', function () {
    initializeAllP7Sliders();

    setTimeout(initializeAllP7Sliders, 1000);

    if (window.Fancybox) {
        Fancybox.defaults = {
            dragToClose: true,
            hideScrollbar: true,
            Toolbar: {
                display: ["close"]
            }
        };
    }
});

function setupFancyboxDefaults() {
    if (!window.Fancybox) return;

    Fancybox.defaults = {
        dragToClose: true,
        hideScrollbar: true,
        Toolbar: {
            display: ["close"]
        }
    };
}

// Run now
setupFancyboxDefaults();

// Run again if Fancybox loads later
Object.defineProperty(window, 'Fancybox', {
    set(value) {
        this._Fancybox = value;
        setupFancyboxDefaults();
    },
    get() {
        return this._Fancybox;
    }
});


if (typeof wp !== 'undefined') {
    let gutenbergTimeout;

    if (wp.data && wp.data.subscribe) {
        wp.data.subscribe(() => {
            clearTimeout(gutenbergTimeout);
            gutenbergTimeout = setTimeout(() => {
                document.querySelectorAll('.p7-slider-block.p7-slider-initialized').forEach(block => {
                    if (block.swiperInstance) {
                        block.swiperInstance.destroy(true, true);
                        block.classList.remove('p7-slider-initialized');
                    }
                });
                initializeAllP7Sliders();
            }, 100);
        });
    }
}


if (window.frameElement && window.frameElement.classList.contains('is-resizable')) {
    const resizeObserver = new ResizeObserver(() => {
        setTimeout(initializeAllP7Sliders, 50);
    });

    resizeObserver.observe(document.body);
}

if (typeof Swiper === 'undefined') {
    Object.defineProperty(window, 'Swiper', {
        set: function (value) {
            window._Swiper = value;
            if (value) {
                setTimeout(initializeAllP7Sliders, 100);
            }
        },
        get: function () {
            return window._Swiper;
        }
    });
}

if (typeof window !== 'undefined') {
    window.p7Slider = {
        initSlider: initP7Slider,
        initAllSliders: initializeAllP7Sliders,
        destroyAllSliders: function () {
            document.querySelectorAll('.p7-slider-block.p7-slider-initialized').forEach(block => {
                if (block.swiperInstance) {
                    block.swiperInstance.destroy(true, true);
                    block.classList.remove('p7-slider-initialized');
                }
            });
        }
    };
}